/* tslint:disable */

/* eslint-disable */

/**
 * FastAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { exists, mapValues } from "../runtime";
import { User, UserFromJSON, UserFromJSONTyped, UserToJSON } from "./User";

/**
 *
 * @export
 * @interface UserFetchResponse
 */
export interface UserFetchResponse {
  /**
   *
   * @type {User}
   * @memberof UserFetchResponse
   */
  data: User;
}

export function UserFetchResponseFromJSON(json: any): UserFetchResponse {
  return UserFetchResponseFromJSONTyped(json, false);
}

export function UserFetchResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): UserFetchResponse {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    data: UserFromJSON(json["data"]),
  };
}

export function UserFetchResponseToJSON(value?: UserFetchResponse | null): any {
  if (value === undefined) {
    return undefined;
  }
  if (value === null) {
    return null;
  }
  return {
    data: UserToJSON(value.data),
  };
}
